import MatchPwned from './matching.esm.js';
import scoring from './scoring.esm.js';
import FeedbackFactory from './feedback.esm.js';
export { default as haveIBeenPwned } from './haveIBeenPwned.esm.js';

const matcherPwnedFactory = (universalFetch, options, url) => {
  return {
    Matching: MatchPwned(universalFetch, url),
    feedback: FeedbackFactory(options),
    scoring
  };
};

export { matcherPwnedFactory as default };
//# sourceMappingURL=index.esm.js.map
